import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { SearchInputExpanded } from 'module/ui/components/atoms/input/search-input-expanded';
import { Layout } from 'module/ui/components/atoms/layout';
import styled, { css } from 'styled-components';
import { WidthTransition } from 'styles/common';

export const AllSignalsSidebarStyled = styled(Layout.Sider)`
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 100%;
  background: var(--white-100);
  padding: 16px;
  border-right: none;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-right: 1px solid var(--scarlet-gray-40);
`;

export const SidebarSearchWrapper = styled.div`
  margin-bottom: 16px;
`;

export const StyledSearchInput = styled(SearchInputExpanded)`
  input {
    padding: 7px 12px;
    border-radius: 8px;
    border: 1px solid var(--scarlet-gray-40);
    font-size: 14px;
    color: var(--gray-100);
    &::placeholder {
      color: var(--gray-40);
      opacity: 1;
    }
  }
`;

export const SidebarMenuSection = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SidebarMenuItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--gray-100);
  border-radius: 4px;
  background: ${({ selected }) =>
    selected ? 'var(--scarlet-gray-30)' : 'transparent'};
  gap: 8px;
  margin-bottom: 4px;
  padding: 2px 8px 2px 8px;
  height: 32px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: var(--scarlet-gray-30);
  }
`;

export const SidebarDivider = styled.div`
  height: 1px;
  background: rgba(141, 141, 141, 0.1);
  margin: 8px 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px;
  font-size: 14px;
  color: var(--gray-100);
  font-weight: 590;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  height: 32px;
  margin-bottom: 4px;
`;

export const SectionSubItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px 2px 32px;
  font-size: 14px;
  color: var(--gray-100);
  border-radius: 4px;
  background: ${({ selected }) =>
    selected ? 'var(--scarlet-gray-30)' : 'transparent'};
  cursor: pointer;
  transition: background 0.15s;
  height: 32px;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    background: var(--scarlet-gray-30);
  }
  justify-content: space-between;
`;

export const SectionSubItemLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SignalsListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: auto;
`;

export const SignalsContainer = styled.div<{ $isFullWidth?: boolean }>`
  width: 100%;
  ${WidthTransition};
  ${({ $isFullWidth }) =>
    $isFullWidth
      ? css`
          max-width: 100%;
          padding: 0 var(--spacing-06);
        `
      : css`
          max-width: 560px;
        `};
`;

export const SignalsContainerListView = styled.div`
  max-width: 100%;
  width: 100%;
  padding-right: 24px;
  padding-left: 24px;
`;

export const SelectedSignalType = styled.div`
  color: var(--gray-100);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
`;

export const EmptyStateIcon = styled(FontAwesomeIcon)`
  color: var(--gray-50);
`;

export const PrimaryActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SecondaryActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StyledSidebarIcon = styled(FontAwesomeIcon)`
  width: 12px;
  height: 12px;
`;

export const StyledSignalIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
`;

export const StyledRectangleHistoryIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
`;

export const StyledMenuIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
`;

export const NoResultsMessage = styled.div`
  padding: var(--spacing-04);
  text-align: center;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
`;

export const FlexSpacer = styled.span`
  flex: 1;
`;
export const FullWidthMenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-02);
`;
